import axios from 'axios'
import qs from 'qs'
import store from '../store'
import {Message} from 'element-ui'
import {is_Empty} from '../utils/utils'

let DOMAIN = 'https://api.beltdance.com/'
// DOMAIN = "http://192.168.1.73:8880/"

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'

function setToken() {
    if (!is_Empty(store.state.memberInfo)) {
        axios.defaults.headers.post['token'] = store.state.memberInfo.member_token;
    }
}

function setRequestParam(params) {
    let obj = {...params}
    obj.requestSource = "PC"
    if (store.state.memberInfo) {
        let login = store.state.memberInfo;
        obj.member_token = login.member_token;
        obj.member_id = login.member_id;
        obj.login_id = login.member_id;
        if (login.company_id) {
            obj.company_id = login.company_id;
        }
    }

    if (store.state.company_id) {
        obj.company_id = store.state.company_id;
    }
    if (store.state.sale_info) {
        obj.sale_token = store.state.sale_info.memberInfo;
    }
    return obj
}

axios.interceptors.request.use(function (config) {
    return config
}, function (error) {
    return Promise.reject(error)
});
// 响应拦截器即异常处理
axios.interceptors.response.use(response => {
    return response
}, err => {
    if (err && err.response) {
        console.log(err, 'error')
        switch (err.response.status) {
            case 400:
                Message.error('错误请求')
                break
            case 401:
                Message.error('未授权，请重新登录')
                break
            case 403:
                Message.error('拒绝访问')
                break
            case 404:
                Message.error('请求错误,未找到该资源')
                break
            case 405:
                Message.error('请求方法未允许')
                break
            case 408:
                Message.error('请求超时')
                break
            case 500:
                Message.error('服务器端出错')
                break
            case 501:
                Message.error('网络未实现')
                break
            case 502:
                Message.error('网络错误')
                break
            case 503:
                Message.error('服务不可用')
                break
            case 504:
                Message.error('网络超时')
                break
            case 505:
                Message.error('http版本不支持该请求')
                break
            default:
                Message.error(`连接错误${err.response.status}`)
        }
    } else {
        Message.error('连接到服务器失败')
    }
    if (err.message == 'token failed') {
        Message.error("登录失效,请重新登录!")
    } else {
        Message.error(err.message)
    }
    return Promise.resolve(err.response)
})

export function get(url, params) {
    setToken()
    return new Promise((resolve, reject) => {
        axios.get(DOMAIN + url, {
            params: params
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}

export function post(url, params) {
    setToken()
    let obj = setRequestParam(params);

    return new Promise((resolve, reject) => {
        axios.post(DOMAIN + url, qs.stringify(obj))
            .then(res => {
                if (res.data.status === 'ok') {
                    resolve(res.data)
                } else {
                    // 如果是token失效 跳转授权页面
                    if (res.data.error === "token failed") {
                        Message.error(`登录失效`)
                        window.location.href = '/login'
                    } else {
                        Message.error(`${res.data.error}`)
                    }
                    reject(res.data)
                }
            })
            .catch(err => {
                reject(err.data)
            })
    })
}

export function jsonPost(url, params) {
    let obj = setRequestParam(params);

    return new Promise((resolve, reject) => {

        axios.post(DOMAIN + url, obj, {
            headers: {
                'Content-Type': 'application/json;charset:utf-8;'
            }
        })
            .then(res => {
                if (res.data.status === 'ok') {
                    resolve(res.data)
                } else {
                    // 如果是token失效 跳转授权页面
                    if (res.data.error == "token failed") {
                        Message.error(`登录失效`)
                        window.location.href = '/login'
                    }
                    reject(res.data)
                    Message.error(`${res.data.error}`)
                }
            })
            .catch(err => {
                console.log('err')
                reject(err.data)
            })

    })
}


export function postWithUserInfo(url, params) {
    setToken()

    let obj = setRequestParam(params);
    // axios.defaults.withCredentials = true;
    return new Promise((resolve, reject) => {
        axios.post(DOMAIN + url, qs.stringify(obj))
            .then(res => {
                if (res.data.status == 'ok') {
                    resolve(res.data)
                } else {
                    // 如果是token失效 跳转授权页面
                    if (res.data.error == "token failed") {
                        console.log("token 失效")
                        window.location.href = '/login'
                    }
                    resolve(res.data)
                    Message.error(`${res.data.error}`)
                }
            })
            .catch(err => {
                reject(err.data)
            })
    })
}

export function upload(file) { //file为 你读取成功的回调文件信息
    //new 一个FormData格式的参数
    setToken()
    let params = new FormData()
    for (let i = 0; i < file.length; i++) {
        params.append('files', file[i])
    }

    let config = {
        headers: { //添加请求头
            'Content-Type': 'multipart/form-data'
        }
    }
    return new Promise((resolve, reject) => {
        //把 uploadUrl 换成自己的 上传路径
        axios.post(DOMAIN + '/settingInterfaces/v1.0/uploadImgs', params, config).then(res => {
            if (res.data.status == 'ok') { //如果为真 resolve出去
                resolve(res.data.data)
            } else {
                reject(res.data)
                //否则 Toast 提示
                // this.$message({
                //     message: res.data && (res.data.msg),
                //     type: "error"
                // })
            }
        }).catch(err => {
            this.$message("系统异常")
            reject(err)
        });
    })
}




// WEBPACK FOOTER //
// ./src/http/api.js